import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { LIBRARIES } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'access',
    label: 'Access Level',
  },
  {
    key: 'owner',
    label: 'Owner',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/libraries/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Libraries = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Libraries</Title>

      <Link to="/libraries/new">
        <Text>Build Library</Text>
      </Link>

      <RelayTable
        query={LIBRARIES}
        queryName="libraries"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default Libraries;
